import { render } from "./AbsibIcon.vue?vue&type=template&id=1a492c68&ts=true"
import script from "./AbsibIcon.vue?vue&type=script&lang=ts"
export * from "./AbsibIcon.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__